import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FiCalendar } from 'react-icons/fi';

type DatePickerProps = {
	selected?: Date;
	onChange: (date: Date | null) => void;
	minDate?: Date;
	dateFormat?: string;
	timeFormat?: string;
	showTimeSelect?: boolean;
};

const NotificationDatePicker = ({
	selected,
	onChange,
	minDate,
	dateFormat = 'MM-dd-yyyy HH:mm',
	timeFormat = 'HH:mm',
	showTimeSelect = true,
}: DatePickerProps) => {
	return (
		<div className="relative w-full max-w-sm ml-1 z-50 ">
			<DatePicker
				selected={selected}
				onChange={onChange}
				minDate={minDate}
				showTimeSelect={showTimeSelect}
				timeFormat={timeFormat}
				dateFormat={dateFormat}
				className=" w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
				calendarClassName=" p-4"
			/>
			<span className="absolute left-2 top-3 text-gray-500 pointer-events-none">
				<FiCalendar size={20} />
			</span>
		</div>
	);
};

export default NotificationDatePicker;
